import { TextField } from '@mui/material';
import React from 'react'

const MultilineTextBox = ({ label, value, setValue, rows, disabled }) => {
    return (
        <div>
            <TextField
                label={label}
                multiline
                disabled={disabled}
                fullWidth
                value={value}
                rows={rows}
                onChange={(event) => {
                    setValue(event.target.value);
                }}
            />
        </div>
    )
}

export default MultilineTextBox